/**
 * @example
 *  - ['employee']
 *  - ['employee', 'list', <filters>]
 *  - ['employee', 'detail', <id>]
 */
const EmployeeQueryKeys = {
  all: () => ['employee'] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...EmployeeQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id?: number) =>
    [
      ...EmployeeQueryKeys.all(),
      'detail',
      ...(id !== undefined ? [id] : [])
    ] as const
};

export default EmployeeQueryKeys;
